module.exports = __webpack_public_path__ + "img/xxtz.2f147938.png";